<template>
  <section
    class="maxwidthcategories mx-auto grid grid-cols-1 gap-x-40 1xl:grid-cols-categories_desktop py-55px px-8"
  >
    <BtnFiltrar class="mb-33 block 1xl:hidden" />
    <Sidebar
      @clicked="getcourseid($event)"
      @category_name="getname($event)"
      @seeall="getallCourses"
      :categories="GET_CATEGORIES"
      class="hidden 1xl:block"
    />

    <div class="pl-0 lg:pl-40  gap-40">
          <div
          @click="$router.go(-1)"
          class="blue-font cursor-pointer my-3 d-flex align-items-center text-skin-description"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style="max-width:17px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
          </svg>
          <span class="ml-2">volver</span>
        </div>
      <h2
        class="pl-10px lg:pl-0 mb-25 text-left	font-semibold	 text-skin-secondary text-l "
      >
        <span v-if="all_courses == true">Todos los cursos</span>
        <span v-else
          >Cursos de {{ category }}
          <span v-if="!category">{{ GET_CURRENT }}</span>
        </span>
      </h2>
      <div
        class="grid grid-cols-1 gap-y-40 md:grid-cols-2fr lg:grid-cols-3fr justify-items-center lg:justify-items-stretch	 1xl:grid-cols-3fr "
      >
        <CourseCard
          :explore_card="true"
          v-for="(course, index) in courses.data"
          :key="index"
          :course="course"
          :name="course.name"
          :parse="true"
          :parse_data="course.mounted_course_data"
          :description="course.description"
          :owner_name="course.propietary_name"
          :owner_lname="course.propietary_lastname"
          :users_in_course="course.users_in_course"
          :image="course.image"
          :destacate="course.destacate"
        />

      </div>

      <Pagination
        v-if="courses.total > 0"
        @prev="prevpage"
        @next="nextpage"
        :current_page="currentPage"
        :last_page="courses.last_page"
      />
      <CoursesEmptyState v-if="courses.total === 0"/>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import CourseCard from "../components/CourseCard.vue";
import Sidebar from "../components/Sidebar.vue";
import Pagination from "../components/Pagination.vue";
import CoursesEmptyState from "../components/CoursesEmptyState.vue";
import BtnFiltrar from "../components/BtnFiltrar.vue";

export default {
  components: {
    CourseCard,
    Sidebar,
    Pagination,
    CoursesEmptyState,
    BtnFiltrar,
  },
  data() {
    return {
      currentPage: 1,
      currentTotal: 1,
      perPage:9,
      all_courses: true,
      category: null,
      categoryId: null,
    };
  },
  mounted() {
    let x = window.matchMedia("(max-width: 450px)");
    
    this.perPage =  x.matches ? 1 : 9

    this.$store.dispatch("allcourses/get_courses", {
      perPage: this.perPage,
      currentPage: this.currentTotal,
      query: this.$route.query.q,
    });
    if(localStorage.getItem("cat"))
      this.all_courses= false

    this.$store.dispatch("categories/get_categories");
  },
  computed: {
    ...mapGetters(["MENUOPEN", "OPENMODAL", "GET_CURRENT"]),
    ...mapGetters("allcourses", ["GET_COURSES"]),
    ...mapGetters("categories", ["GET_CATEGORIES"]),
    ...mapGetters("categoryCourses", ["GET_CATEGORYCOURSES"]),
    ...mapGetters("categories", ["GET_CURRENTCAT"]),
    searchValue(){
      return this.$route.query.q
    },
    courses(){
      if (this.all_courses) {
        return this.GET_COURSES
      }else
        return this.GET_CATEGORYCOURSES
    }
  },
  methods: {
    getcourseid(value) {
      this.all_courses = false;
      this.$router.push({ name: "v2-categories",
        params:{
          id:value
        },
        query:{
          q:''
        }
      });
      this.categoryId = value;
      this.$store.dispatch("categoryCourses/get_categoryCourses", {
        categoryId: this.$route.params.id,
        perPage: 9,
        currentPage: this.currentPage,
      });
    },

    getname(value) {
      this.category = value;
    },

    getallCourses() {
      this.all_courses = true;
      this.$store.dispatch("allcourses/get_courses", {
        perPage: this.perPage,
        currentPage: this.currentTotal,
        query: '',
      });
    },

    nextpage() {
      if (this.currentPage < this.GET_CATEGORYCOURSES.last_page) {
        let nextpage = this.currentPage + 1;
        this.currentPage = this.currentPage + 1;

        this.$store.dispatch("categoryCourses/get_categoryCourses", {
          categoryId: this.categoryId,
          perPage: this.perPage,
          currentPage: nextpage,
        });

      }
    },

    prevpage() {
      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        let prevpage = this.currentPage - 1;

        this.$store.dispatch("categoryCourses/get_categoryCourses", {
          categoryId: this.categoryId,
          perPage: this.perPage,
          currentPage: prevpage,
        });
      }
    },

    nexttotal() {
      if (this.currentTotal < this.GET_COURSES.last_page) {
        let nextpage = this.currentTotal + 1;
        this.currentTotal = this.currentTotal + 1;
        this.$store.dispatch("allcourses/get_courses", {
          perPage: this.perPage,
          currentPage: nextpage,
        });
      }
    },

    prevtotal() {
      if (this.currentTotal > 1) {
        this.currentTotal = this.currentTotal - 1;
        let prevpage = this.currentTotal - 1;
        this.$store.dispatch("allcourses/get_courses", {
          perPage: this.perPage,
          currentPage: prevpage,
        });

      }
    },
  },
  watch:{
    searchValue(){
      this.$store.dispatch("allcourses/get_courses", {
        perPage: this.perPage,
        currentPage: this.currentTotal,
        query: this.searchValue,
      });
    },
  },
};
</script>
